/* eslint-disable */
import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import {
  FiArrowRight, FiCheckCircle, FiZap, FiMessageCircle,
  FiTrendingUp, FiShield, FiRefreshCw, FiBell, FiUsers, FiCpu
} from "react-icons/fi";
import AppNavbar from "../components/Navbar.js";
import AppFooter from "../components/Footer.js";

const TEAL = "#00AA87";
const NAVY = "#0F172A";
const PURPLE = "#4F46B5";
const SLATE = "#334155";
const LIGHT = "#F8FAFC";

export default function Moji() {
  const sixCards = [
    { icon: <FiCpu size={22} />, title: "Understand", desc: "Builds a living picture of each learner — goals, habits, constraints.", color: TEAL },
    { icon: <FiTrendingUp size={22} />, title: "Detect", desc: "Identifies early changes in engagement and behaviour.", color: TEAL },
    { icon: <FiZap size={22} />, title: "Decide", desc: "Selects the intervention most likely to drive re-engagement.", color: PURPLE },
    { icon: <FiMessageCircle size={22} />, title: "Act", desc: "Coaches the learner and adapts their plan conversationally.", color: TEAL },
    { icon: <FiBell size={22} />, title: "Escalate", desc: "Loops in humans — peers, mentors, tutors — when AI isn't enough.", color: PURPLE },
    { icon: <FiRefreshCw size={22} />, title: "Learn", desc: "Uses outcomes to sharpen every future decision for that learner.", color: PURPLE },
  ];

  const comparison = [
    ["Videos & quizzes", "Understands motivation"],
    ["Static reminders", "Learns individual habits"],
    ["Generic notifications", "Detects disengagement"],
    ["Progress tracking", "Adapts in real time"],
    ["Reactive intervention", "Predicts risk before dropout"],
  ];

  const phases = [
    {
      label: "Phase 1 — Now", title: "Digital Skills & Workforce", color: TEAL,
      items: ["Training providers", "Bootcamps", "Government upskilling", "TVET institutions"],
    },
    {
      label: "Phase 2 — Next", title: "Institutional Learning", color: PURPLE,
      items: ["Universities & NGOs", "Certification bodies", "Development organisations", "International programmes"],
    },
    {
      label: "Phase 3 — Later", title: "Workforce & Lifelong Learning", color: "#0F172A",
      items: ["Enterprise learning", "Corporate upskilling", "Career development", "Learning infrastructure APIs"],
    },
  ];

  return (
    <div style={{ backgroundColor: LIGHT, minHeight: "100vh", fontFamily: "'Manrope', 'Inter', sans-serif" }}>
      <style>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        
        .animate-fade-in {
          animation: fadeInUp 0.8s cubic-bezier(0.16, 1, 0.3, 1) forwards;
          opacity: 0;
        }

        .delay-100 { animation-delay: 100ms; }
        .delay-200 { animation-delay: 200ms; }
        .delay-300 { animation-delay: 300ms; }

        .hover-lift {
          transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1), box-shadow 0.3s cubic-bezier(0.16, 1, 0.3, 1);
        }
        .hover-lift:hover {
          transform: translateY(-6px);
          box-shadow: 0 12px 24px rgba(15, 23, 42, 0.08) !important;
        }
        
        .hover-btn {
          transition: all 0.2s ease;
        }
        .hover-btn:hover {
          transform: scale(1.05);
        }
        
        .hover-btn-outline {
          transition: all 0.2s ease;
        }
        .hover-btn-outline:hover {
          background-color: rgba(15, 23, 42, 0.05) !important;
          border-color: ${NAVY} !important;
        }
      `}</style>
      <AppNavbar hideOnScroll={true} />

      <main style={{ paddingTop: "88px" }}>

        {/* ── 01 HERO ─────────────────────────────────────────── */}
        <section className="text-center py-5" style={{ paddingBottom: "80px !important" }}>
          <Container style={{ maxWidth: "820px" }}>
            <div className="py-5 animate-fade-in">
              <h1 style={{
                fontSize: "clamp(3rem, 6vw, 5rem)",
                fontWeight: 900,
                color: TEAL,
                letterSpacing: "-2px",
                lineHeight: 1,
                marginBottom: "16px",
              }}>
                Moji
              </h1>
              <p className="animate-fade-in delay-100" style={{ fontSize: "clamp(1.1rem, 2.2vw, 1.4rem)", color: SLATE, fontWeight: 600, marginBottom: "12px" }}>
                AI infrastructure for learning completion.
              </p>
              <p style={{
                fontSize: "clamp(1rem, 1.8vw, 1.2rem)",
                color: "#64748B",
                fontStyle: "italic",
                maxWidth: "580px",
                margin: "0 auto 40px",
                lineHeight: 1.6,
              }}>
                "Learning platforms deliver the course.<br />
                Moji helps learners finish it."
              </p>
              <div className="d-flex flex-wrap justify-content-center gap-3 animate-fade-in delay-200">
                <a href="mailto:moa@motivar.live" className="text-decoration-none">
                  <button className="hover-btn" style={{
                    background: TEAL, color: "#fff", border: "none",
                    borderRadius: "999px", padding: "14px 32px",
                    fontWeight: 700, fontSize: "1rem", cursor: "pointer",
                    display: "flex", alignItems: "center", gap: "8px",
                  }}>
                    Talk to the team <FiArrowRight size={18} />
                  </button>
                </a>
                <a href="mailto:moa@motivar.live" className="text-decoration-none">
                  <button className="hover-btn-outline" style={{
                    background: "transparent", color: NAVY,
                    border: `2px solid #CBD5E1`, borderRadius: "999px",
                    padding: "14px 32px", fontWeight: 700, fontSize: "1rem", cursor: "pointer",
                  }}>
                    Request a demo
                  </button>
                </a>
              </div>
            </div>
          </Container>
        </section>

        {/* ── 02 THE PROBLEM ──────────────────────────────────── */}
        <section className="py-5" style={{ backgroundColor: "#fff", borderTop: "1px solid #E2E8F0" }}>
          <Container>
            <Row className="align-items-center g-5">
              <Col lg={5}>

                <h2 style={{ fontSize: "clamp(1.8rem, 3vw, 2.6rem)", fontWeight: 900, color: NAVY, lineHeight: 1.2, marginBottom: "20px" }}>
                  Learning doesn't fail because of content.
                  <span style={{ color: SLATE }}> It fails because of human behaviour.</span>
                </h2>
                <p style={{ color: SLATE, fontSize: "1rem", lineHeight: 1.7, marginBottom: "24px" }}>
                  Millions of people start online courses and digital-skills programmes every year.
                  Too many never reach the finish line.
                </p>
                <div className="d-flex flex-column gap-2">
                  {["Loss of motivation", "Competing responsibilities", "Poor study habits", "Lack of accountability", "Isolation"].map(r => (
                    <div key={r} className="d-flex align-items-center gap-2">
                      <div style={{ width: "8px", height: "8px", borderRadius: "50%", backgroundColor: TEAL, flexShrink: 0 }} />
                      <span style={{ color: SLATE, fontWeight: 600, fontSize: "0.95rem" }}>{r}</span>
                    </div>
                  ))}
                </div>
              </Col>
              <Col lg={7}>
                {/* Funnel Visual */}
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 0 }}>
                  {[
                    { label: "100 learners start", w: "100%", bg: TEAL, text: "#fff" },
                    { label: "Engagement begins to drop", w: "80%", bg: "#0D8E72", text: "#fff" },
                    { label: "Motivation fades", w: "62%", bg: PURPLE, text: "#fff" },
                    { label: "Dropout risk rises", w: "44%", bg: "#3730A3", text: "#fff" },
                    { label: "Only a fraction complete", w: "26%", bg: NAVY, text: "#fff" },
                  ].map((s, i) => (
                    <div key={i} style={{
                      width: s.w, backgroundColor: s.bg, color: s.text,
                      borderRadius: i === 0 ? "12px 12px 0 0" : i === 4 ? "0 0 12px 12px" : "0",
                      padding: "14px 20px", fontWeight: 700, fontSize: "0.9rem",
                      textAlign: "center", transition: "all 0.3s",
                    }}>
                      {s.label}
                    </div>
                  ))}
                </div>
              </Col>
            </Row>
            <div className="text-center mt-5 pt-3">
              <p style={{ color: NAVY, fontWeight: 700, fontSize: "1.1rem", maxWidth: "680px", margin: "0 auto" }}>
                Today's learning systems optimise for content delivery.<br />
                <span style={{ color: SLATE, fontWeight: 500 }}>Few are designed around sustained learner behaviour.</span>
              </p>
            </div>
          </Container>
        </section>

        {/* ── 03 THE GAP ──────────────────────────────────────── */}
        <section className="py-5">
          <Container>
            <div className="text-center mb-5">
              <h2 style={{ fontSize: "clamp(1.8rem, 3vw, 2.5rem)", fontWeight: 900, color: NAVY, lineHeight: 1.2 }}>
                Learning platforms manage content.<br />
                <span style={{ color: TEAL }}>Moji manages the learner.</span>
              </h2>
            </div>
            <Row className="g-4 justify-content-center">
              <Col lg={5}>
                <div className="hover-lift" style={{ backgroundColor: "#F1F5F9", borderRadius: "16px", padding: "32px", height: "100%", border: "1px solid transparent" }}>
                  <p style={{ fontWeight: 800, color: "#64748B", fontSize: "0.8rem", letterSpacing: "1px", textTransform: "uppercase", marginBottom: "20px" }}>
                    Traditional Learning Platforms
                  </p>
                  <div className="d-flex flex-column gap-3">
                    {comparison.map(([l]) => (
                      <div key={l} className="d-flex align-items-center gap-2" style={{ color: "#64748B", fontSize: "0.95rem", fontWeight: 500 }}>
                        <span style={{ width: "20px", height: "20px", borderRadius: "50%", border: "2px solid #CBD5E1", display: "inline-flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>—</span>
                        {l}
                      </div>
                    ))}
                  </div>
                </div>
              </Col>
              <Col lg={5}>
                <div className="hover-lift" style={{ backgroundColor: "rgba(0,170,135,0.08)", border: `2px solid ${TEAL}`, borderRadius: "16px", padding: "32px", height: "100%" }}>
                  <p style={{ fontWeight: 800, color: TEAL, fontSize: "0.8rem", letterSpacing: "1px", textTransform: "uppercase", marginBottom: "20px" }}>
                    Moji
                  </p>
                  <div className="d-flex flex-column gap-3">
                    {comparison.map(([, r]) => (
                      <div key={r} className="d-flex align-items-center gap-2" style={{ color: NAVY, fontSize: "0.95rem", fontWeight: 600 }}>
                        <FiCheckCircle size={20} color={TEAL} style={{ flexShrink: 0 }} />
                        {r}
                      </div>
                    ))}
                  </div>
                </div>
              </Col>
            </Row>

          </Container>
        </section>

        {/* ── 04 THE SOLUTION ─────────────────────────────────── */}
        <section className="py-5" style={{ backgroundColor: "#fff", borderTop: "1px solid #E2E8F0", borderBottom: "1px solid #E2E8F0" }}>
          <Container>
            <div className="text-center mb-5">
              <h2 style={{ fontSize: "clamp(1.8rem, 3vw, 2.5rem)", fontWeight: 900, color: NAVY, marginBottom: "16px" }}>
                Meet Moji
              </h2>
              <p style={{ color: SLATE, fontSize: "1.1rem", maxWidth: "620px", margin: "0 auto", lineHeight: 1.6 }}>
                An AI coach that continuously understands, supports and adapts to each learner — until they reach their goal.
              </p>
            </div>
            <Row className="g-3">
              {sixCards.map((c, i) => (
                <Col key={i} md={4} sm={6}>
                  <div className="hover-lift" style={{
                    backgroundColor: LIGHT, border: "1px solid #E2E8F0", borderRadius: "16px",
                    padding: "24px", height: "100%",
                  }}>
                    <div style={{
                      width: "44px", height: "44px", borderRadius: "10px",
                      backgroundColor: `${c.color}15`, color: c.color,
                      display: "flex", alignItems: "center", justifyContent: "center",
                      marginBottom: "14px",
                    }}>
                      {c.icon}
                    </div>
                    <h5 style={{ fontWeight: 800, color: NAVY, marginBottom: "8px", fontSize: "1rem" }}>{c.title}</h5>
                    <p style={{ color: SLATE, fontSize: "0.9rem", margin: 0, lineHeight: 1.6 }}>{c.desc}</p>
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        {/* ── 10 VALIDATION ───────────────────────────────────── */}
        <section className="py-5" style={{ backgroundColor: "#fff", borderTop: "1px solid #E2E8F0" }}>
          <Container>
            <div className="text-center mb-5">
              <p style={{ color: TEAL, fontWeight: 700, fontSize: "0.85rem", letterSpacing: "1px", textTransform: "uppercase", marginBottom: "12px" }}>
                Early Evidence
              </p>
              <h2 style={{ fontSize: "clamp(1.8rem, 3vw, 2.5rem)", fontWeight: 900, color: NAVY }}>
                Moji can influence learner behaviour.
              </h2>
            </div>
            <Row className="g-4 mb-5">
              {[
                { num: "200+", label: "Learners supported" },
                { num: "2×", label: "Completion improvement" },
                { num: "4", label: "Cohorts & programmes" },
                { num: "$1,000", label: "Grant received" },
              ].map((s, i) => (
                <Col key={i} md={3} sm={6}>
                  <div style={{
                    backgroundColor: LIGHT, border: "1px solid #E2E8F0",
                    borderRadius: "16px", padding: "28px 20px", textAlign: "center",
                  }}>
                    <p style={{ fontSize: "2.4rem", fontWeight: 900, color: TEAL, margin: "0 0 6px" }}>{s.num}</p>
                    <p style={{ color: SLATE, margin: 0, fontWeight: 600, fontSize: "0.9rem" }}>{s.label}</p>
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        {/* ── 11 CUSTOMER ─────────────────────────────────────── */}
        <section className="py-5">
          <Container>
            <div className="text-center mb-5">
              <h2 style={{ fontSize: "clamp(1.8rem, 3vw, 2.5rem)", fontWeight: 900, color: NAVY, lineHeight: 1.2 }}>
                We sell to organisations that already spend money<br />getting people to learn.
              </h2>
            </div>
            <Row className="g-4 justify-content-center">
              <Col lg={5}>
                <div className="hover-lift" style={{ backgroundColor: LIGHT, border: "1px solid #E2E8F0", borderRadius: "16px", padding: "32px", height: "100%" }}>
                  <div className="d-flex align-items-center gap-2 mb-4">
                    <FiUsers size={20} color={TEAL} />
                    <p style={{ fontWeight: 800, color: NAVY, margin: 0 }}>Who buys</p>
                  </div>
                  {["Training providers & bootcamps", "Government upskilling programmes", "Digital-skills organisations", "Distance learning institutions", "Development organisations"].map(i => (
                    <div key={i} className="d-flex align-items-start gap-2 mb-2">
                      <FiCheckCircle size={16} color={TEAL} style={{ marginTop: "3px", flexShrink: 0 }} />
                      <span style={{ color: SLATE, fontWeight: 500, fontSize: "0.95rem" }}>{i}</span>
                    </div>
                  ))}
                </div>
              </Col>
              <Col lg={5}>
                <div className="hover-lift" style={{ backgroundColor: "rgba(79,70,181,0.06)", border: `1px solid rgba(79,70,181,0.2)`, borderRadius: "16px", padding: "32px", height: "100%" }}>
                  <div className="d-flex align-items-center gap-2 mb-4">
                    <FiZap size={20} color={PURPLE} />
                    <p style={{ fontWeight: 800, color: NAVY, margin: 0 }}>Why they buy</p>
                  </div>
                  {["More learners complete without adding headcount", "Proactive dropout detection before it's too late", "Full visibility into learner behaviour & risk", "Scalable AI coaching at a fraction of the cost", "Measurable outcomes and cohort analytics"].map(i => (
                    <div key={i} className="d-flex align-items-start gap-2 mb-2">
                      <FiCheckCircle size={16} color={PURPLE} style={{ marginTop: "3px", flexShrink: 0 }} />
                      <span style={{ color: SLATE, fontWeight: 500, fontSize: "0.95rem" }}>{i}</span>
                    </div>
                  ))}
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        {/* ── 14 CLOSING CTA ──────────────────────────────────── */}
        <section className="py-5" style={{ paddingBottom: "80px" }}>
          <Container>
            <div style={{
              background: `linear-gradient(135deg, ${NAVY} 0%, #1E293B 100%)`,
              borderRadius: "24px", padding: "64px 40px", textAlign: "center",
            }}>
              <h2 style={{ fontSize: "clamp(1.8rem, 3.5vw, 3rem)", fontWeight: 900, color: "#fff", lineHeight: 1.2, marginBottom: "40px" }}>
                Learning should not stop<br />when motivation does.
              </h2>
              <Row className="g-4 justify-content-center mb-5">
                {[
                  { stage: "Today", desc: "Help learners finish online courses." },
                  { stage: "Tomorrow", desc: "Help organisations improve learning outcomes at scale." },
                  { stage: "Eventually", desc: "Power the intelligence layer behind lifelong learning across Africa." },
                ].map((s, i) => (
                  <Col key={i} md={4}>
                    <div style={{ borderTop: `2px solid ${i === 0 ? TEAL : i === 1 ? "#818CF8" : "#94A3B8"}`, padding: "20px 0 0" }}>
                      <p style={{ color: i === 0 ? TEAL : i === 1 ? "#818CF8" : "#94A3B8", fontWeight: 800, fontSize: "0.75rem", letterSpacing: "2px", textTransform: "uppercase", marginBottom: "8px" }}>{s.stage}</p>
                      <p style={{ color: "#E2E8F0", fontSize: "0.95rem", margin: 0, lineHeight: 1.6 }}>{s.desc}</p>
                    </div>
                  </Col>
                ))}
              </Row>
              <p style={{ color: TEAL, fontWeight: 900, fontSize: "3rem", marginBottom: "8px" }}>Moji</p>
              <p style={{ color: "#F8FAFC", marginBottom: "40px", fontSize: "1.25rem", fontWeight: 500, lineHeight: 1.6 }}>
                An intelligent coach for every learner.<br />An intelligence layer for every learning provider.
              </p>
              <div className="d-flex flex-wrap justify-content-center gap-3">
                <a href="mailto:moa@motivar.live" className="text-decoration-none">
                  <button className="hover-btn" style={{
                    background: TEAL, color: "#fff", border: "none",
                    borderRadius: "999px", padding: "18px 40px",
                    fontWeight: 800, fontSize: "1.2rem", cursor: "pointer",
                    display: "flex", alignItems: "center", gap: "10px",
                    boxShadow: "0 8px 16px rgba(0, 170, 135, 0.3)"
                  }}>
                    moa@motivar.live <FiArrowRight size={22} />
                  </button>
                </a>
              </div>
            </div>
          </Container>
        </section>

      </main>
      <AppFooter />
    </div>
  );
}
